import { createFileRoute, Outlet, useLocation, useNavigate } from "@tanstack/react-router"
import { useAuth } from "hooks/use-auth"
import { useUserType } from "hooks/use-user-type"
import { useEffect } from "react"
import { Page } from "@/components/page"
import { Typography } from "@/components/ui/typography"

export const Route = createFileRoute("/_authed/_individual")({
  component: IndividualLayout,
})

function IndividualLayout() {
  const { isAuthenticated, isLoading } = useAuth()
  const { isIndividual, hasOnboarded } = useUserType()
  const navigate = useNavigate()
  const pathname = useLocation({ select: (location) => location.pathname })

  useEffect(() => {
    if (!isLoading && isAuthenticated && !isIndividual) {
      navigate({
        to: "/professional/clients",
        replace: true,
      })
    }
  }, [isAuthenticated, isLoading, isIndividual, navigate])

  useEffect(() => {
    if (!isLoading && isAuthenticated && isIndividual && !hasOnboarded) {
      const isOnboardingRoute = pathname.startsWith("/onboarding")
      if (!isOnboardingRoute) {
        navigate({
          to: "/onboarding/emergency-contacts",
          replace: true,
        })
      }
    }
  }, [hasOnboarded, isAuthenticated, isIndividual, isLoading, navigate, pathname])

  if (isLoading) {
    return (
      <Page>
        <Typography as="h1" size="2xl">
          Loading...
        </Typography>
      </Page>
    )
  }

  if (!isAuthenticated || !isIndividual) {
    return null // Will redirect in useEffect
  }

  return <Outlet />
}
